import { urlValidator } from '@issuemanager/apps/client/utils';
import {
  IssueTypeValues,
  SourceAppValues,
  SourceEntityTypeValues,
} from '@issuemanager/constants';
import { z } from 'zod';

export const integrationSourceUrlParamsSchema = z.object({
  type: z.enum(IssueTypeValues),
  sourceApp: z.enum(SourceAppValues),
  sourceEntityType: z.enum(SourceEntityTypeValues),
  sourceEntityId: z.string().min(1).max(64),
  sourceEntityName: z.string().min(1).max(300),
  sourceEntityLink: z
    .string()
    .min(1)
    .max(2048)
    .refine((url) => urlValidator(url)),
  callbackUrl: z
    .string()
    .min(1)
    .max(2048)
    .refine((url) => urlValidator(url)),
});
export type IntegrationSourceUrlParams = z.infer<
  typeof integrationSourceUrlParamsSchema
>;
